import React, { useContext } from 'react';
import { Accordion } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { AccordionContent, RootContainer, RootWrapper } from '../styled';
import DocumentsTable from './DocumentsTable';
import Photos from './Photos';

const Documents = ({ employeeId }) => {
  const { t } = useContext(ConfigContext);

  return (
    <RootWrapper>
      <RootContainer>
        <Accordion defaultOpenRows={{ 0: true }}>
          <Accordion.Item title={t('documents')}>
            <AccordionContent>
              <DocumentsTable />
            </AccordionContent>
          </Accordion.Item>
        </Accordion>

        <Accordion defaultOpenRows={{ 0: true }}>
          <Accordion.Item title={t('photos')}>
            <AccordionContent>
              <Photos employeeId={employeeId} />
            </AccordionContent>
          </Accordion.Item>
        </Accordion>
      </RootContainer>
    </RootWrapper>
  );
};

export default Documents;
